import { throttle } from 'lodash-es';
import SelectorEngine from '../../utils/dom/selector-engine';
import BaseComponent from '../BaseComponent';
import EventHandler from '../../utils/dom/event-handler';

const NAME = 'MapView';
class MapView extends BaseComponent {
	constructor(element) {
		super(element);
		this._element = element;
		this.courtPage = SelectorEngine.findOne('.p-find-a-court');
		this.Cookies = undefined;
		this.views = SelectorEngine.find('.js-court-view', this.courtPage);
		this.isMapActive = SelectorEngine.findOne('.js-lta-mapview.js-court-view-active', this.courtPage) != undefined;
		this.changeBtn = SelectorEngine.find('.js-court-view .js-change-views', this.courtPage);
		this.viewHeight = undefined;
		this.results = undefined;
		this.resultsWrapper = undefined;
		this.offsetBottom = undefined;
		this.card = undefined;
		this.cardHeight = 0;
		this.orientation = false;

		this.init();
	}

	static get NAME() {
		return NAME;
	}

	init() {
		this.resultsWrapper = SelectorEngine.findOne('.lta-mapview-results');
		this.results = SelectorEngine.findOne('.lta-mapview-overflow');
		if (this.results) {
			this.card = SelectorEngine.findOne('.lta-card-court-booking', this.results);
			this.cardHeight = this.card ? this.card.clientHeight : 0;
		}

		this.initCookiesLib().then(() => this.changeViews());
		this.computeHeight();

		// Deprecated
		EventHandler.on(window, 'orientationchange', this.computeHeight);

		EventHandler.on(screen.orientation, 'change', this.computeHeight);

		//Detect browser

		const userAgent = navigator.userAgent;

		if (userAgent.match(/firefox|fxios/i)) {
			SelectorEngine.findOne('.lta-mapview-results-wrapper .lta__map').classList.add('browser-firefox');
		}

		const self = this;
		let previousScroll = 0,
			up = false;

		const handleScroll = () => {
			up = document.documentElement.scrollTop < previousScroll;
			previousScroll = document.documentElement.scrollTop;
			let currentScroll = document.documentElement.scrollTop + window.innerHeight;

			this.orientation ? currentScroll -= this.cardHeight : currentScroll += this.cardHeight;

			if (currentScroll >= self.offsetBottom && !up) {
				self.resultsWrapper.classList.add('not-fixed');
			} else if (up && (currentScroll < self.offsetBottom + 32)) {
				self.resultsWrapper.classList.remove('not-fixed');
			}
		};

		EventHandler.on(window, 'scroll', throttle(handleScroll, 10));

		EventHandler.on(window, 'orientationchange', () => {
			this.orientation = !this.orientation;
			this.computeOffset();
		});
	}

	computeOffset() {
		let top = document.documentElement.scrollTop + window.innerHeight;

		this.orientation ? top -= this.cardHeight : top += this.cardHeight;
		this.offsetBottom = this.results.offsetTop + this.results.parentElement.offsetTop + this.results.clientHeight;
		if (top >= this.offsetBottom) {
			this.resultsWrapper.classList.add('not-fixed');
		} else {
			this.resultsWrapper.classList.remove('not-fixed');
		}

	}

	changeViews() {
		if (this.Cookies.get('default-view') == 'map') {
			this.isMapActive = !this.isMapActive;
			const listview = SelectorEngine.findOne('.js-lta-listview', this.courtPage);
			if (listview) listview.classList.remove('js-court-view-active');
			const mapview = SelectorEngine.findOne('.js-lta-mapview', this.courtPage);
			if (mapview) mapview.classList.add('js-court-view-active');
			this.isMapActive = true;
			setTimeout(() => {
				this.computeOffset();
			}, 100);
		}

		this.Cookies.set('default-view', this.isMapActive ? 'map' : 'list');

		this.changeBtn.forEach((e) => {
			EventHandler.on(e, 'click', (event) => {
				event.stopPropagation();
				event.preventDefault();
				this.isMapActive = !this.isMapActive;
				this.views.forEach((el) => el.classList.toggle('js-court-view-active'));
				this.Cookies.set('default-view', this.isMapActive ? 'map' : 'list');
				this.isMapActive ? this.computeOffset() : '';
			});
		});
	}

	computeHeight() {
		this.viewHeight = window.innerHeight - 72;
		const mapview = SelectorEngine.findOne('.js-lta-mapview', this.courtPage);
		if (mapview) {
			mapview.style = '--viewHeight:' + this.viewHeight + 'px';
		}
	}

	initCookiesLib() {
		return import('js-cookie')
			.then(({ default: Cookies }) => {
				this.Cookies = Cookies;
				return this.Cookies;
			})
			.catch((error) => {
				console.log(error);
			});
	}
}

export default MapView;
